// ============================================================================
// JAPANESE TRANSLATIONS - CHAPTER 1: 創世記
// ============================================================================
// レベル 1-13 (13レベル、39問)

export const chapter1Translations = {
  name: "創世記",
  description: "初めに...知識は霊を生かす",
  
  spiritualWisdom: {
    principle: "知識は霊を生かす",
    scripture: "わが民は知識がないために滅ぼされる (ホセア書4:6)",
    application: "学んだすべての節、発見したすべての真理が私たちの魂を養い、信仰を強めます"
  },
  
  levels: {
    1: {
      name: "天地創造",
      challenge: "初めに、神は天と地とを創造された...",
      easy: {
        question: "神は何日で世界を創造されましたか?",
        options: ["5日", "6日", "7日", "8日"],
        correct: 1,
        hint: "週の休息日を考えて",
        funFact: "💡 第7日目に神は休まれました。これが安息日、週の休息日の起源です!"
      },
      medium: {
        question: "神は第4日目に何を創造されましたか?",
        options: ["動物", "人間", "太陽、月、星", "植物"],
        correct: 2,
        hint: "これらの被造物は地を照らし、時を定めます",
        funFact: "🌟 光る物は季節と宗教的な祭りを定めるために創造されました!"
      },
      hard: {
        question: "人が「神のかたち」に造られたとはどういう意味ですか?",
        options: [
          "同じ外見",
          "創造し愛する能力",
          "自然な不死",
          "神の力"
        ],
        correct: 1,
        hint: "霊的・知的な性質のことです",
        funFact: "✨ 私たちの内にある神のかたちには、創造性、道徳的良心、愛する能力が含まれます!"
      }
    },
    
    2: {
      name: "園の誘惑",
      challenge: "蛇は野の獣のうちで、最も狡猾であった...",
      easy: {
        question: "園でエバを誘惑した動物は何ですか?",
        options: ["ライオン", "蛇", "鷲", "龍"],
        correct: 1,
        hint: "この動物は腹で這います",
        funFact: "🐍 蛇は聖書全体で誘惑と狡猾さを象徴します!"
      },
      medium: {
        question: "蛇はエバにどんな嘘の約束をしましたか?",
        options: [
          "不死になる",
          "裕福になる",
          "神のようになる",
          "幸せになる"
        ],
        correct: 2,
        hint: "蛇は神のレベルへの昇格を約束します",
        funFact: "🎭 蛇の嘘は真実と欺きを混ぜます - 古典的な誘惑の技術です!"
      },
      hard: {
        question: "この堕落は善悪の闘いをどのように照らしますか?",
        options: [
          "悪の方が強い",
          "自由意志は責任を意味する",
          "神は私たちを見捨てる",
          "誘惑は無敵"
        ],
        correct: 1,
        hint: "選択し結果を負う能力のことです",
        funFact: "🌳 知識の木は人類を定義する道徳的選択を象徴します!"
      }
    },
    
    3: {
      name: "カインとアベル",
      challenge: "二人の兄弟、二つの捧げ物、永遠のドラマ...",
      easy: {
        question: "聖書の歴史で最初の殺人者は誰ですか?",
        options: ["アベル", "セツ", "カイン", "アダム"],
        hint: "アベルを妬んだ兄弟",
        funFact: "⚡ カインは破壊的な兄弟嫉妬の象徴になります!"
      },
      medium: {
        question: "神がアベルの捧げ物を好んだのはなぜですか?",
        options: [
          "量が多かった",
          "アベルの方が美しかった",
          "誠実な心で捧げられた",
          "肉だった"
        ],
        hint: "神は心を見られます",
        funFact: "❤️ 神は心を見られます、私たちの行いの外見だけではありません!"
      },
      hard: {
        question: "この物語は嫉妬について何を教えていますか?",
        options: [
          "嫉妬は自然",
          "制御されない嫉妬は破壊につながる",
          "神は一部を贔屓する",
          "競争は健全"
        ],
        hint: "感情を制御しない結果のことです",
        funFact: "🔥 '罪が門のところに待ち伏せている' - 神は堕落の前に警告されます!"
      }
    },

    4: {
      name: "ノアの洪水",
      challenge: "地の上に四十日四十夜、雨が降った...",
      easy: {
        question: "洪水の雨は何日何晩降りましたか?",
        options: ["30日", "40日", "50日", "100日"],
        hint: "聖書の象徴的な数字",
        funFact: "☔ 40という数字は聖書で試練と変化を象徴します!"
      },
      medium: {
        question: "ノアは方舟に清い動物を何組入れるべきでしたか?",
        options: [
          "1組",
          "2組",
          "7組",
          "10組"
        ],
        hint: "汚れた動物より多く",
        funFact: "🦁 清い動物は洪水後の犠牲のためでした!"
      },
      hard: {
        question: "方舟は私たちの霊的な旅で何を象徴しますか?",
        options: [
          "問題からの逃避",
          "信仰と従順による救い",
          "必要な孤立",
          "信者の優越性"
        ],
        hint: "信じる者に提供される救いのことです",
        funFact: "🚢 方舟は救いを予示します:裁きから逃れる一つの道!"
      }
    },

    5: {
      name: "バベルの塔",
      challenge: "さあ、町と塔とを建てて、その頂を天に届かせよう...",
      easy: {
        question: "神はバベルで何を混乱させましたか?",
        options: ["計画", "言語", "道具", "思考"],
        hint: "コミュニケーションを可能にするもの",
        funFact: "🗣️ バベルは世界の言語多様性の神話的起源です!"
      },
      medium: {
        question: "人々はなぜこの塔を建てたかったのですか?",
        options: [
          "身を守るため",
          "共に住むため",
          "名を上げ天に届くため",
          "神を称えるため"
        ],
        hint: "傲慢と神と等しくなりたいという願望のことです",
        funFact: "🏗️ 神と等しくなろうとする傲慢は常に混乱につながります!"
      },
      hard: {
        question: "バベルの傲慢は今日どのように現れていますか?",
        options: [
          "技術だけで",
          "神なしの絶対的自律への人間の意志で",
          "高層ビルで",
          "異なる言語で"
        ],
        hint: "神なしでやっていこうとすることです",
        funFact: "💭 バベルは、神なしの一致が破壊的な傲慢になることを思い出させます!"
      }
    },

    6: {
      name: "アブラハムの召命",
      challenge: "あなたは国を出て、親族に別れ、父の家を離れ...",
      easy: {
        question: "アブラハムが国を出たとき何歳でしたか?",
        options: ["50歳", "65歳", "75歳", "100歳"],
        hint: "すべてをやり直すには非常に高齢",
        funFact: "🚶 75歳でアブラハムは新しい人生を始めます - 遅すぎることはありません!"
      },
      medium: {
        question: "神はアブラハムにどんな三重の約束をされましたか?",
        options: [
          "富、権力、知恵",
          "土地、子孫、普遍的祝福",
          "長寿、平和、繁栄",
          "信仰、希望、愛"
        ],
        hint: "全人類に関わる約束",
        funFact: "🌟 アブラハムへの約束は全人類に関わります、彼だけではありません!"
      },
      hard: {
        question: "アブラハムの「信仰の飛躍」は何を教えていますか?",
        options: [
          "盲信は危険",
          "神に従うには安全を手放す必要がある",
          "神は特定の民を好む",
          "信仰は成功を保証する"
        ],
        hint: "基準を放棄して信頼することです",
        funFact: "✨ アブラハムは見ずに信じたので「信仰の父」と呼ばれます!"
      }
    },

    7: {
      name: "イサクの犠牲",
      challenge: "あなたの子、あなたの愛するひとり子イサクを連れて...",
      easy: {
        question: "アブラハムはどの山でイサクを捧げるはずでしたか?",
        options: ["シナイ", "モリヤ", "カルメル", "シオン"],
        hint: "この山は聖なる場所になります",
        funFact: "🏔️ モリヤ山はエルサレム神殿の場所になります!"
      },
      medium: {
        question: "神はイサクの代わりに何を備えられましたか?",
        options: [
          "子羊",
          "角を茂みに掛けた雄羊",
          "山羊",
          "雄牛"
        ],
        hint: "角のある成獣の雄",
        funFact: "🐏 代わりの雄羊は究極の代理犠牲を予示します!"
      },
      hard: {
        question: "この試練は絶対的な信仰をどのように示しますか?",
        options: [
          "神は残酷に試す",
          "信仰は父の愛さえも超越する",
          "人身御供は神を喜ばせる",
          "アブラハムは本当にイサクを愛していなかった"
        ],
        hint: "理解できなくても信頼することです",
        funFact: "💝 私たちが神を信頼するとき、神は常に脱出路を備えられます!"
      }
    },

    8: {
      name: "ヤコブとエサウ",
      challenge: "兄は弟に仕える...",
      easy: {
        question: "エサウは何のために長子の権利を売りましたか?",
        options: ["金", "レンズ豆の煮物", "衣服", "ぶどう酒"],
        hint: "空腹を満たすための一皿",
        funFact: "🍲 一時の飢えがエサウから永遠の祝福を奪いました!"
      },
      medium: {
        question: "ヤコブはどのようにして父イサクを欺きましたか?",
        options: [
          "声を変えた",
          "変装した",
          "山羊の皮で身を覆った",
          "名前について嘘をついた"
        ],
        hint: "毛深い兄に似せるために",
        funFact: "🎭 目の見えないイサクは、においと感触は認識できましたが、欺きには気づきませんでした!"
      },
      hard: {
        question: "この物語は私たちの選択について何を明らかにしていますか?",
        options: [
          "欺きは時に必要である",
          "即座の欲望は運命を犠牲にする可能性がある",
          "神は狡猾さを認める",
          "弟が常に優遇される"
        ],
        hint: "衝動的な決定の結果についてです",
        funFact: "⚖️ 私たちの衝動的な選択は永遠の結果をもたらす可能性があります!"
      }
    },

    9: {
      name: "ヤコブの夢",
      challenge: "地に立てられたはしごを見た。その頂は天に達していた...",
      easy: {
        question: "ヤコブは夢の中で何を見ましたか?",
        options: [
          "巨大な木",
          "天使たちのいる天への梯子",
          "神殿",
          "星々"
        ],
        hint: "天と地の間の通信手段",
        funFact: "👼 ヤコブの梯子は天と地のつながりを象徴しています!"
      },
      medium: {
        question: "ヤコブは枕にしていた石をどうしましたか?",
        options: [
          "それを壊した",
          "それを埋めた",
          "それを立てて油を注いだ",
          "それを持って行った"
        ],
        hint: "神聖な記念碑にした",
        funFact: "🪨 この石は「ベテル」-神の家になります!"
      },
      hard: {
        question: "このビジョンは私たちの生活の中で天と地をどのように結びつけますか?",
        options: [
          "夢だけを通して",
          "神とのつながりを確立する祈りを通して",
          "守護天使を通して",
          "聖なる場所を通して"
        ],
        hint: "神との私たちのコミュニケーションについてです",
        funFact: "🌉 祈りは天への私たちの個人的な梯子です!"
      }
    },

    10: {
      name: "兄弟たちに売られたヨセフ",
      challenge: "見よ、あの夢見る者が来る...",
      easy: {
        question: "ヨセフには何人の兄弟がいましたか?",
        options: ["7人の兄弟", "10人の兄弟", "11人の兄弟", "12人の兄弟"],
        hint: "イスラエルの部族の数より一つ少ない",
        funFact: "👨‍👨‍👦‍👦 ヤコブの12人の息子はイスラエルの12部族になります!"
      },
      medium: {
        question: "ヨセフは何枚の銀貨で売られましたか?",
        options: [
          "10枚",
          "20枚",
          "30枚",
          "50枚"
        ],
        hint: "奴隷の値段",
        funFact: "💰 20枚の銀貨、当時の奴隷の価格でした!"
      },
      hard: {
        question: "嫉妬はどのようにして神の計画の道具になりますか?",
        options: [
          "神は嫉妬を認める",
          "行われた悪は神によって善に変えられる",
          "嫉妬は必要である",
          "兄弟たちは正しかった"
        ],
        hint: "悪を善に変える神の摂理についてです",
        funFact: "🎨 神は私たちの最悪の行いさえも恵みの傑作に変えられます!"
      }
    },

    11: {
      name: "牢獄のヨセフ",
      challenge: "主はヨセフと共におられ、彼に慈しみを注がれた...",
      easy: {
        question: "ヨセフにはどんな特別な賜物がありましたか?",
        options: [
          "予言する",
          "夢を解釈する",
          "病人を癒す",
          "動物と話す"
        ],
        hint: "夢に関連する能力",
        funFact: "💭 夢は古代世界で神のメッセージと見なされていました!"
      },
      medium: {
        question: "ヨセフと一緒に牢獄にいたファラオの家来は誰でしたか?",
        options: [
          "大臣と書記",
          "献酌官と料理官",
          "医師と番人",
          "料理人と庭師"
        ],
        hint: "ぶどう酒を出す者とパンを出す者",
        funFact: "🍷 献酌官は毒殺を防ぐために王のぶどう酒を味見していました!"
      },
      hard: {
        question: "ヨセフは逆境における忠実さについて何を教えてくれますか?",
        options: [
          "不正義は受け入れられる",
          "神への忠実さは状況を超越する",
          "牢獄は人を変える",
          "復讐すべきである"
        ],
        hint: "試練の中でも忠実であり続けることについてです",
        funFact: "⭐ 牢獄の中でさえ、ヨセフは誠実であり続け、神は彼を引き上げられました!"
      }
    },

    12: {
      name: "ファラオの夢",
      challenge: "七頭の肥えた雌牛... 七頭の痩せた雌牛...",
      easy: {
        question: "何頭の痩せた雌牛が肥えた雌牛を食い尽くしましたか?",
        options: ["5", "6", "7", "8"],
        hint: "完全な数",
        funFact: "🐄 数字の7は聖書において完全さと豊かさを象徴しています!"
      },
      medium: {
        question: "夢の中の7年は何を意味していましたか?",
        options: [
          "7年間の戦争の後に平和",
          "7年間の豊作の後に7年間の飢饉",
          "7年間の病気の後に健康",
          "7年間の雨の後に干ばつ"
        ],
        hint: "豊かさと不足のサイクル",
        funFact: "🌾 ヨセフはこの解釈によってエジプトと家族を救いました!"
      },
      hard: {
        question: "神の知恵はどのように危機を変えますか?",
        options: [
          "すべての危機を避ける",
          "準備するための先見の明を与える",
          "悪人を罰する",
          "信者を豊かにする"
        ],
        hint: "準備と予測についてです",
        funFact: "💡 神の知恵は危機を救いの機会に変えます!"
      }
    },

    13: {
      name: "兄弟たちの和解",
      challenge: "私はヨセフです。あなたがたが売った兄弟です...",
      easy: {
        question: "ヨセフはベニヤミンの袋に何を入れましたか?",
        options: [
          "金",
          "自分の指輪",
          "自分の銀の杯",
          "手紙"
        ],
        hint: "貴重な個人的な物",
        funFact: "🏆 その杯は水で未来を'読む'のにも使われました!"
      },
      medium: {
        question: "ヨセフは悪が善に変えられたことについて何という有名な言葉を言いましたか?",
        options: [
          "私はあなたがたを赦します",
          "あなたがたは私に悪を企てましたが、神はそれを善に変えてくださいました",
          "過去を忘れましょう",
          "復讐は神のもの"
        ],
        hint: "神の摂理についての言葉",
        funFact: "✨ この言葉は私たちの生活における神の摂理のすべてを要約しています!"
      },
      hard: {
        question: "赦しはどのように復讐の連鎖を断ち切りますか?",
        options: [
          "悪を忘れる",
          "加害者と被害者の両方を新しい始まりのために解放する",
          "まず罰する",
          "距離を保つ"
        ],
        hint: "相互の解放についてです",
        funFact: "🕊️ ヨセフの赦しは普遍的な神の赦しを予示しています!"
      }
    }
  }
};

export default chapter1Translations;
